import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/card/card";
import ImageViewer from "../../../components/ImageViewer";
import { printDate, printLocation } from "../../../utils/helper";
import React, { useState, useEffect } from "react";
import { user, user as userAPI } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import { useQuery } from "@tanstack/react-query";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import ModalChangeUser from "./modal/changeUsers";
import { useDashboardContext } from "../../../contexts/NewDashboardContext";

import ConfirmationDlg from "../../../components/ConfirmationDlg";

function UserConfiguration() {
  const [openDetail, setOpenDetail] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [confirmDlg, setConfirmDlg] = useState(false);
  const { addSetupDone, selectedApp } = useDashboardContext();

  const [users, setUsers] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteRow, setDeleteRow] = useState(null);

  async function getUser() {
    try {
      const res = await userAPI.list();
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.length) {
          let tmp = [];
          data.map((i, index) => {
            let item = i;
            item.id = index + 1;
            tmp.push(item);
          });
          setUsers(tmp);
          setIsDirty(false);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    getUser();
  }, [isDirty]);

  function selectUser(value) {
    //console.log("selected machine", value);
  }
  function addUser(value) {
    setOpenDetail(true);
  }
  function editUser(value) {
    setSelectedRow(value);
    setOpenDetail(true);
  }

  function showConfirmationDlg(row) {
    setDeleteRow(row);
    setConfirmDlg(true);
  }
  function hideConfirmationDialog() {
    setDeleteRow(null);
    setConfirmDlg(false);
  }

  async function deleteUser() {
    try {
      const res = await userAPI.delete(deleteRow.username);
      if (res.ok) {
        toast.success("This user has been deleted");
        setConfirmDlg(false);
        setDeleteRow(null);
        const body = await res.json();
        setIsDirty(true);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  const columns = [
    {
      name: "Email",
      selector: (row) => row.email,
    },
    {
      name: "Name",
      minWidth: "200px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return (
          <span>
            {row.firstname} {row.lastname}
          </span>
        );
      },
    },
    {
      name: "Role",
      selector: (row) =>
        selectedApp == "CMMS"
          ? row.companies[0].cmms_role?.name
          : row.companies[0].role?.rolename,
    },
    {
      name: "Action",
      width: "150px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return (
          <div>
            <button
              onClick={() => {
                editUser(row);
              }}
              className="btn btn-sm btn-outline-theme mx-1"
            >
              <i className="fa fa-edit"></i>
            </button>
            <button
              onClick={() => {
                showConfirmationDlg(row);
              }}
              className="btn btn-sm btn-outline-danger"
            >
              <i className="fa fa-trash"></i>
            </button>
          </div>
        );
      },
    },
  ];
  async function onSubmit({
    password,
    email,
    jobTitle,
    firstname,
    lastname,
    contactNumber,
    userRole,
    status,
  }) {
    let data = {
      password,
      email,
      job_title: jobTitle,
      firstname,
      lastname,
      //contact_number: contactNumber,
      role_id: userRole,
      //is_active: status == 1 ? true : false,
      is_staff: false,
      app: selectedApp,
    };
    if (!selectedRow) {
      const response = await userAPI.create(data);
      const body = await response.json();
      if (response.ok) {
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("New user is successfully added");
          setSelectedRow(null);
          setOpenDetail(false);
          setIsDirty(true);
          await addSetupDone({ user_setup_center: "team" });
        } else {
          toast.error(body.message);
        }
      } else {
        if (response.status == 409) {
          toast.error(body.message);
        } else {
          toast.error("Something went wrong");
        }
      }
    } else {
      const response = await userAPI.update(selectedRow.username, data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("User is successfully updated");
          setSelectedRow(null);
          setOpenDetail(false);
          setIsDirty(true);
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    }
  }

  return (
    <div>
      <ModalChangeUser
        onSubmit={onSubmit}
        open={openDetail}
        row={selectedRow}
        onClose={() => {
          setSelectedRow(null);
          setOpenDetail(false);
        }}
      ></ModalChangeUser>
      <ConfirmationDlg
        open={confirmDlg}
        onClose={() => {
          setConfirmDlg(false);
          setDeleteRow(null);
        }}
        onSubmit={deleteUser}
      >
        <div>Are you sure you want to delete this User?</div>
      </ConfirmationDlg>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Configuration</a>
            </li>
            <li className="breadcrumb-item active">Users</li>
          </ol>
          <h1 className="page-header mb-0">Users</h1>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-12 ">
          <div className="row justify-content-end">
            <div className="col-sm-3 mb-2 mb-sm-0">
              <button onClick={addUser} className="btn btn-outline-theme w-100">
                Add User <i className="bi bi-plus"></i>
              </button>
            </div>
          </div>
          <Card className="mb-4 mt-2">
            <CardHeader>Update User Profile</CardHeader>
            <CardBody>
              <DataTable
                pointerOnHover
                onRowClicked={(row) => {
                  editUser(row);
                }}
                highlightOnHover
                theme="dark"
                columns={columns}
                data={users}
                pagination
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default UserConfiguration;
